import { Modal } from "react-bootstrap";
import styles from "./Modal.module.scss";
import { useTranslation } from "react-i18next";
import ActionButton from "../Buttons/Action/ActionButton";

interface LevelUpModalProps {
  show: boolean;
  newLevel: number;
  onDismiss: () => void;
}

const LevelUpModal = ({ show, newLevel, onDismiss }: LevelUpModalProps) => {
  const { t } = useTranslation();
  if (!show) return null;

  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      className={styles.modalWindow}
      show={show}
      centered
      onHide={onDismiss}
    >
      <Modal.Header className={styles.modalHeader}>
        <Modal.Title className={styles.modalTitle}>
          {t("game.levelUp")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.modalBody}>
        <div className="levelBadge">
          <div className="hexagon"></div>
          <p className="levelBadgeText">{newLevel}</p>
        </div>
      </Modal.Body>
      <Modal.Footer className={styles.modalBody}>
        <div className={styles.modalButtonContainer}>
          <ActionButton className={styles.modalButton} onClick={onDismiss}>
            {t("common.close")}
          </ActionButton>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default LevelUpModal;
